import React from "react";
import { Helmet } from "react-helmet-async";
import Card from "@mui/material/Card";

import InformationHome from "pages/Servicii/ServiciiCuratenie/CuratareMocheteCovoare/sections/sections/InformationHome";
import TestimonialsHome from "pages/Servicii/ServiciiCuratenie/CuratareMocheteCovoare/sections/sections/TestimonialsHome";
import HeroSection from "pages/Servicii/ServiciiCuratenie/CuratareMocheteCovoare/sections/sections/HeroSection";
import ServicesSection from "pages/Servicii/ServiciiCuratenie/CuratareMocheteCovoare/sections/sections/Services";
import ArticleContent from "pages/Servicii/ServiciiCuratenie/CuratareMocheteCovoare/sections/sections/ArticleContent";

function CuratareMocheteCovoarePage() {
    return (
        <>
            <Helmet>
                <title>Curățare Mochete Profesională | Igienizare Textile | Doral Cleaning</title>
                <meta
                    name="description"
                    content="Curățare profesională a mochetelor și suprafețelor textile prin metode adaptate materialului: aspirare, tratarea petelor, curățare în profunzime și igienizare."
                />
                <link rel="canonical" href="https://doral-cleaning.ro/curatare-mochete/" />
                <script type="application/ld+json">
                    {`
                    {
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    "mainEntity": [
                        {
                        "@type": "Question",
                        "name": "Cât durează procesul de curățare?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Depinde de suprafață, însă, ca o medie, o echipă de 2 persoane poate curăța aproximativ 100-150 mp de mochetă pe oră în condiții standard de birou."
                        }
                        },
                        {
                        "@type": "Question",
                        "name": "Mocheta va rămâne udă?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Tehnologia noastră de extracție lasă mocheta ușor umedă la atingere, nu saturată. Timpul de uscare variază între 2 și 6 ore, în funcție de ventilația din încăpere și de grosimea materialului."
                        }
                        },
                        {
                        "@type": "Question",
                        "name": "Se pot scoate toate petele?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Deși avem rate de succes excelente (peste 95%), anumite pete vechi de acid, clor sau coloranți textile pot altera permanent fibra. Putem însă să atenuăm vizibil contrastul."
                        }
                        },
                        {
                        "@type": "Question",
                        "name": "Curățați și covoare la domiciliu sau birou?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Da, oferim curățare profesională pentru covoare chiar la locația dumneavoastră, adaptând metoda (spălare sau curățare uscată) în funcție de proveniența covorului (oriental, sintetic, lână)."
                        }
                        }
                    ]
                    }
                    `}
                </script>
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": "LocalBusiness",
                      "@id": "https://doral-cleaning.ro/#business",
                      "name": "Doral Cleaning - Servicii profesionale de curatenie",
                      "url": "https://doral-cleaning.ro/",
                      "telephone": "0730 407 322",
                      "foundingDate": "2006",
                      "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Calea Șerban Vodă 82, Sector 4",
                        "addressLocality": "București",
                        "postalCode": "040213",
                        "addressCountry": "RO"
                      },
                      "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 44.4202372718721,
                        "longitude": 26.10209372955662
                      },
                      "areaServed": [
                        { "@type": "City", "name": "București" },
                        { "@type": "AdministrativeArea", "name": "Județul Ilfov" },
                        { "@type": "City", "name": "Voluntari" },
                        { "@type": "City", "name": "Pantelimon" },
                        { "@type": "City", "name": "Popești-Leordeni" },
                        { "@type": "City", "name": "Bragadiru" },
                        { "@type": "City", "name": "Măgurele" },
                        { "@type": "City", "name": "Chitila" },
                        { "@type": "City", "name": "Buftea" },
                        { "@type": "City", "name": "Otopeni" }
                      ]
                    }
                    `}
                </script>
            </Helmet>
            <HeroSection />
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    zIndex: 1,
                    backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                        rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <TestimonialsHome />
                <InformationHome />
                <ArticleContent />
                <ServicesSection />
            </Card>
        </>
    );
}

export default CuratareMocheteCovoarePage;
